import create, { SetState, StateCreator, StoreApi } from "zustand";

interface EolStore {
  keyNumbersData: any;
  setKeyNumbersData: (x: any) => void;
  dataCardId?: number;
  setDataCardId: (x: number) => void;
  clearStore: () => void;
}

let store: StateCreator<EolStore, [], [], EolStore> | StoreApi<EolStore> = (set: SetState<EolStore>) => ({
  keyNumbersData: null,
  setKeyNumbersData: (x) => {
    set(() => ({ keyNumbersData: x }));
  },
  dataCardId: undefined,
  setDataCardId: (dataCardId) => {
    set(() => ({ dataCardId }));
  },
  clearStore: () => {
    set(() => ({ keyNumbersData: null, dataCardId: undefined }));
  },
});

export const useKeyNumbersStore = create(store);